module.exports = __webpack_public_path__ + "img/ground-sea-morning.fb2a1a01.png";